import _ from 'underscore';
import Chart from 'chartjs';
import moment from 'moment';
import i18n from 'l10n';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';

var it = {
};
var isPostpaid = false;

var queryOptions = {
    from: null, //long millis
    to: null, //long millis
    unit: null,
    window: null,
    dow: null //first day of week (0-Sunday ...)
};
it.options = {
    from: null, //moment
    to: null, //moment
    window: null,
    fromAll: null,
    toAll: null,
    unitAll: null,
    queryOptions: queryOptions
};
it.division = {
    all: {divisions: ['month'], def: 'month'},
    day: {divisions: ['hour'], def: 'hour'},
    week: {divisions: ['day'], def: 'day'},
    month: {divisions: ['week', 'day'], def: 'day'},
    year: {divisions: ['month', 'week'], def: 'month'}
};

it.moreLessDetails = function (inc) {
    var division = this.division[this.options.window];
    var curr = _.indexOf(division.divisions, this.options.queryOptions.unit);
    if (curr >= 0 && curr + inc >= 0 && curr + inc < division.divisions.length) { //paranoid check
        this.options.queryOptions.unit = division.divisions[curr + inc];
        $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
        if (this.options.queryOptions.unit === _.first(division.divisions)) {
            $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
        } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
            $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
        }
        this.refresh();
    }
};

it.setWindow = function (timegranule) {
    var now = moment();
    var previousWindow = this.options.window;
    var goingToDayFromEnclosingWindow = this.options.window !== 'day' && timegranule === "day" && now.isBetween(this.options.from, this.options.to);
    if (timegranule === "*day") timegranule = "day";

    this.options.window = timegranule;
    this.options.queryOptions.window = timegranule;
    var division = this.division[timegranule];
    this.options.queryOptions.unit = division.def;
    if (division.divisions.length === 1) {
        $(this.selector).find(".zoom-buttons").find('button').addClass('disabled');
    } else {
        $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
        if (this.options.queryOptions.unit === _.first(division.divisions)) {
            $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
        } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
            $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
        }
    }
    if (timegranule === 'all') {
        this.options.queryOptions.unit = this.options.unitAll;
        this.options.from = this.options.fromAll;
        this.options.to = this.options.toAll;
        this.options.queryOptions.from = this.options.from.toDate().getTime();
        this.options.queryOptions.to = this.options.to.toDate().getTime();
        $(this.selector).find('.pagination').find('li').addClass('disabled');
        $(this.selector).find('.pagination').find('.spaces').html(i18n.t('reports.allbutton'));
    }
    else {
        var startOf = previousWindow !== 'month' && goingToDayFromEnclosingWindow ? now.startOf("day") : this.options.from.clone().startOf(this.options.window);
        this.options.from = startOf;
        this.options.queryOptions.from = startOf.toDate().getTime();
        var endOf = startOf.clone().endOf(this.options.window);
        this.options.to = endOf;
        this.options.queryOptions.to = endOf.toDate().getTime();

        var startOfString = startOf.format('ll');
        var endOfString = endOf.format('ll');
        $(this.selector).find('.pagination').find('li').removeClass('disabled');
        $(this.selector).find('.pagination').find('.spaces').html(startOfString + ' - ' + endOfString);
    }
};

it.init = function (selector, service, campaignId, parentIsPostpaid, startDate) {
    var self = this;
    this.options.queryOptions.dow = moment().localeData().firstDayOfWeek();
    this.options.service = service;
    this.options.campaignId = campaignId;

    this.selector = selector;

    $(this.selector).find(".timegranule-buttons > button").on('click', function (evt) {
        var btn = $(evt.currentTarget);
        var tg = btn.attr("data-timegranule");

        //set the clicked button to active
        btn.parent().find(".active").removeClass("active");
        btn.addClass("active");

        self.setWindow(tg);
        self.refresh();
    });

    $(this.selector).find('.pagination').find('.prev').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            self.options.from.subtract(1, self.options.window + 's');
            self.setWindow(self.options.window);
            self.refresh();
        }
    });

    $(this.selector).find('.pagination').find('.next').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            self.options.from.add(1, self.options.window + 's');
            self.setWindow(self.options.window);
            self.refresh();
        }
    });

    $(this.selector).find(".zoom-buttons").find('.minus').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            self.moreLessDetails(-1);
        }
    });

    $(this.selector).find(".zoom-buttons").find('.plus').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            self.moreLessDetails(+1);
        }
    });

    var dateFrom = moment(startDate).startOf('month');
    var one_day = 1000 * 60 * 60 * 24;
    self.options.fromAll = dateFrom;
    var date2_ms = moment().toDate().getTime();
    self.options.toAll = moment().endOf('day');
    var difference_ms = date2_ms - dateFrom;
    // Convert back to days and check
    if (Math.round(difference_ms / one_day) < 30) {
        self.options.unitAll = "day";
    }
    else if (Math.round(difference_ms / one_day) < 49) {
        self.options.unitAll = "week";
    }
    else {
        self.options.unitAll = "month";
    }

    isPostpaid = parentIsPostpaid;

    $(self.selector).find(".timegranule-buttons").find("[data-timegranule='all']").addClass('active');
    self.setWindow('all');
    self.refresh();
};

it.refresh = function () {

    $.ajaxDefaultQ({
        url: '/CampaignCloud/RememberMeController/ping',
        type: 'GET',
        dataType: "json"
    }).done(function (response) {
        if (response.status === 'success') {
            console.log(`Going to ${it.options.from.format('ll')}(${it.options.queryOptions.from}) - ${it.options.to.format('ll')}(${it.options.queryOptions.to}) window=${it.options.window} unit=${it.options.queryOptions.unit} dow=${it.options.queryOptions.dow}`);
            $.ajaxDefaultQ({
                url: `/CampaignCloud/Report/${it.options.service}/${it.options.campaignId}/getServiceDataSentUsed`,
                type: 'POST',
                data: JSON.stringify(it.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            }).done(function (json) {
                if (json.unit) {
                    $(it.selector).find('#serviceChartXAxisLabel').text(i18n.t("reports.label-" + json.unit));
                }

                if (it.serviceChart) {
                    it.serviceChart.destroy();
                }

                var labels = i18n.labels(it.options.from, it.options.window, it.options.queryOptions.unit, json.servicesSent.length);
                var servicesSentLabel = it.options.service === "Survey" ?
                    i18n.t('reports.Surveyssent') :
                    (it.options.service === "Voucher" ?
                        i18n.t('reports.voucherssentchartlabel') :
                        (it.options.service === "Optin" ?
                            i18n.t('reports.optinVisitslabel') :
                            i18n.t('instantWin.views_plural')));
                var servicesUsedLabel = it.options.service === "Survey" ?
                    i18n.t('engagement.surveysSubmitted') :
                    (it.options.service === "Voucher" ?
                        i18n.t('engagement.vouchersRedeemed') :
                        (it.options.service === "Optin" ?
                            i18n.t('reports.optinAcquisitionsLabel') :
                            i18n.t('instantWin.participants_plural')));
                var data = {
                    labels: labels,
                    datasets: [
                        {
                            label: servicesSentLabel,
                            fillColor: ch.colors.mauveUno.transparent,
                            strokeColor: ch.colors.mauveUno.solid,
                            pointColor: ch.colors.mauveUno.solid,
                            pointStrokeColor: "#fff",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: ch.colors.mauveUno.solid,
                            data: json.servicesSent
                        },
                        {
                            label: servicesUsedLabel,
                            fillColor: ch.colors.blueDue.transparent,
                            strokeColor: ch.colors.blueDue.solid,
                            pointColor: ch.colors.blueDue.solid,
                            pointStrokeColor: "#fff",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: ch.colors.blueDue.solid,
                            data: json.servicesUsed
                        }
                    ]
                };

                if (it.options.service === "InstantWin") {
                    var winnersLabel = i18n.t("instantWin.winner_plural");

                    data.datasets.push({
                        label: winnersLabel,
                        fillColor: ch.colors.greenTre.transparent,
                        strokeColor: ch.colors.greenTre.solid,
                        pointColor: ch.colors.greenTre.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.greenTre.solid,
                        data: json.winners
                    });
                }

                if (it.options.service === "PayPalPayment") {
                    var buyersLabel = i18n.t("optin.buyer_plural");

                    data.datasets.push({
                        label: buyersLabel,
                        fillColor: ch.colors.greenTre.transparent,
                        strokeColor: ch.colors.greenTre.solid,
                        pointColor: ch.colors.greenTre.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.greenTre.solid,
                        data: json.buyers
                    });
                }

                var options = {
                    bezierCurve: false,
                    datasetFill: true,
                    responsive: true,
                    legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
                };

                var canvas = $(it.selector).find('#servicesLineChart').get(0);
                var ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                it.serviceChart = new Chart(ctx).Bar(data, options);

                var legend = it.serviceChart.generateLegend();

                $(it.selector).find('#serviceSentUsedLegend').html(legend).click(function () {
                    ch.exportHandler(it.serviceChart);
                });
                $(it.selector).find('#servicesLineChart').unbind("click").bind("click", function (evt) {
                    if (it.options.window !== "day") {
                        var ord = ch.getOrdinalPositionOfEvent(it.serviceChart, evt);

                        //ChartJS, returns -1 if not BAR/LINE clicked
                        //-1 means that the selected date has no data to display
                        if (ord === -1) {
                            return;
                        }

                        it.setWindow(it.goSmaller(it.options.window));
                        $(it.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                        $(it.selector).find(".timegranule-buttons").find("[data-timegranule='" + it.options.window + "']").addClass('active');
                        it.options.from.add(ord, it.options.window + 's');
                        it.setWindow(it.options.window);
                        it.refresh();
                    }
                });

            }).fail(function (response) {
                console.log(response);
            });
        } else {
            console.info(response);
            window.open('Login.htm', '_self');
        }
    }).fail(function (response) {
        console.info(response);
        window.open('Login.htm', '_self');
    });
};

it.goSmaller = function (timegranule) {
    switch (timegranule) {
        case "week":
            return "day";
        case "month":
            return "day";
        case "year":
            return "month";
        case "all":
            return it.options.unitAll === "day" ? "*day" : it.options.unitAll;
    }
};

export default it;
